import { memo, useCallback } from 'react';
import { Button, InfoImage } from '@bonanza-social/moonlight';
import { MaxDuplicatesReachedBottomSheetProps } from './MaxDuplicatesReachedBottomSheet.types';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';

function MaxDuplicatesReachedBottomSheet({
  close,
}: MaxDuplicatesReachedBottomSheetProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleContactSupport = useCallback(() => {
    navigation.navigate('MiscScreen', { path: '/contact' });
    close();
  }, [navigation, close]);

  return (
    <InfoImage
      titleKey="maxDuplicatesTitle"
      titleNS="registration"
      descriptionKey="maxDuplicatesDescription"
      descriptionNS="registration"
    >
      <Button
        locKey="contactSupport"
        locNS="common"
        size="large"
        width="100%"
        onPress={handleContactSupport}
      />
      <Button
        variant="secondary"
        locKey="goBack"
        locNS="common"
        size="large"
        width="100%"
        onPress={close}
      />
    </InfoImage>
  );
}

export default memo(MaxDuplicatesReachedBottomSheet);
